import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useRoles from 'lib/src/hooks/useRoles';

import { logout } from '@actions/auth';

import NavItem from './NavItem';
import { clearJwtToken, clearMfaToken } from 'lib/src/utils/jwt';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import { getTagRouteEndpoint } from '@pages/challengeTags/utils';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';

const Nav: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.toLowerCase();
    const roles = useRoles();
    const hasSuperAdmin = roles.includes(userRoles.superAdmin);
    if (path.startsWith('/auth')) return null;

    return (
        <nav className="navigation custom-scroll">
            <ul className="nav-list">
                <NavItem to="/" text="Dashboard" icon="home" />
                {(hasSuperAdmin || roles.includes(userRoles.assessor)) && (
                    <NavItem to="/assessments" text="Assessments" icon="clipboard" />
                )}
                {hasSuperAdmin && (
                    <NavItem to="/superadmins" text="Super Admins" icon="users-cog" />
                )}
                {(hasSuperAdmin || roles.includes(userRoles.admins)) && (
                    <NavItem to="/admins" text="Admins" icon="users-cog" />
                )}
                {(hasSuperAdmin || roles.includes(userRoles.users)) && (
                    <NavItem to="/users" text="Users" icon="users" />
                )}
                {(hasSuperAdmin ||
                    roles.includes(userRoles.challengeGroups) ||
                    roles.includes(userRoles.challengeView)) && (
                    <NavItem to="/challenge-groups" text="Challenge Groups" icon="trophy" />
                )}
                {hasSuperAdmin && <NavItem to="/challenges" text="Challenges" icon="trophy" />}
                {(hasSuperAdmin || roles.includes(userRoles.challengeTags)) && (
                    <>
                        <NavItem
                            to={`/${getTagRouteEndpoint(tagTypes.tag)}`}
                            text="Challenge IX Programme"
                            icon="tags"
                        />
                        <NavItem
                            to={`/${getTagRouteEndpoint(tagTypes.business)}`}
                            text="Challenge Technology"
                            icon="tags"
                        />
                    </>
                )}
                {(hasSuperAdmin || roles.includes(userRoles.calendar)) && (
                    <NavItem to="/calendar" text="Challenge Calendar" icon="calendar" />
                )}
                {(hasSuperAdmin || roles.includes(userRoles.contactUsMessages)) && (
                    <NavItem to="/contact-us-messages" text="Contact Us Messages" icon="phone" />
                )}
                <NavItem to="/profile" text="My Profile" icon="user" />
                <NavItem
                    to="/auth/login"
                    text="Logout"
                    icon="sign-out"
                    onClick={() => {
                        clearJwtToken();
                        clearMfaToken();
                        dispatch(logout());
                    }}
                />
            </ul>
        </nav>
    );
};

export default Nav;
